export default function ResultPic() {
  return (
    <>
      <div class="result-pic">
        <img src="images/illustration-empty.svg" alt="" />
      </div>
    </>
  );
}
